// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"NavButton-module__nav-button___3E8B1","navButton":"NavButton-module__nav-button___3E8B1","current":"NavButton-module__current___oA4zN"};